export const MODULES = {
    // Workspace
    DASHBOARD: 'dashboard',
    PROFILE: 'profile',
    // Operations
    HRMS_STAFF: 'hrms_staff',
    TRACKER_FDFC: 'tracker_fdfc',
    TRACKER_BDFC: 'tracker_bdfc',
    // System
    MASTER_ROLES: 'master_roles',
    ACCOUNT_ME: 'account_me',
    ACCOUNT_MANAGE: 'account_manage',
    ACCOUNT_PASSWORD: 'account_password',
};
export const ALL_MODULE_CODES = Object.values(MODULES);
export const MODULE_CATEGORIES = {
    WORKSPACE: 'workspace',
    OPERATIONS: 'operations',
    SYSTEM: 'system',
};
export const MODULE_CATEGORY = {
    [MODULES.DASHBOARD]: MODULE_CATEGORIES.WORKSPACE,
    [MODULES.PROFILE]: MODULE_CATEGORIES.WORKSPACE,
    [MODULES.HRMS_STAFF]: MODULE_CATEGORIES.OPERATIONS,
    [MODULES.TRACKER_FDFC]: MODULE_CATEGORIES.OPERATIONS,
    [MODULES.TRACKER_BDFC]: MODULE_CATEGORIES.OPERATIONS,
    [MODULES.MASTER_ROLES]: MODULE_CATEGORIES.SYSTEM,
    [MODULES.ACCOUNT_ME]: MODULE_CATEGORIES.SYSTEM,
    [MODULES.ACCOUNT_MANAGE]: MODULE_CATEGORIES.SYSTEM,
    [MODULES.ACCOUNT_PASSWORD]: MODULE_CATEGORIES.SYSTEM,
};
export const MODULE_LABEL = {
    [MODULES.DASHBOARD]: 'Dashboard',
    [MODULES.PROFILE]: 'My Profile',
    [MODULES.HRMS_STAFF]: 'Staff Management',
    [MODULES.TRACKER_FDFC]: 'FDFC Tracker',
    [MODULES.TRACKER_BDFC]: 'BDFC Tracker',
    [MODULES.MASTER_ROLES]: 'Roles & Permissions',
    [MODULES.ACCOUNT_ME]: 'My Account',
    [MODULES.ACCOUNT_MANAGE]: 'Manage Account',
    [MODULES.ACCOUNT_PASSWORD]: 'Change Password',
};
//# sourceMappingURL=modules.js.map